// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#driver-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding-bottom: 10px;
}

#driver-details-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
  width: 100%;
}
#driver-details-header h4 {
  margin: 5px 30px 5px 70px;
  color: var(--color-primary);
  flex-grow: 1;
  text-align: center;
}

#driver-details-body {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;
  row-gap: 30px;
  padding-top: 5px;
}

#driver-details-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: max(380px, 75%);
}

#driver-details-form, #security-details, #update-info {
  width: max(280px, 60%);
}

#delete-account-btn {
  width: 100%;
}

#driver-details-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-y: auto;
}

.form-control-input {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: white;
  padding: 5px 15px;
  margin: 3px 0;
}

.form-control {
  color: var(--color-primary);
  border: none;
  padding: 0.375rem 0;
}

.form-label {
  color: var(--color-success);
  margin-bottom: 2px;
}

#update-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#logout-btn {
  color: var(--color-primary);
  font-weight: 600;
  font-size: 0.8rem;
  text-decoration: underline;
}

#unsaved-changes-warning {
  font-size: 0.8rem;
}

.invalid-form-field-warning {
  font-size: 0.7rem;
}

#invalid-form-warning, #unsaved-changes-warning, .invalid-form-field-warning {
  color: red;
}

@media only screen and (max-width: 300px) {
  #driver-details-header h4 {
    margin: 5px 30px 5px 30px;
    font-size: calc(1.175rem + 0.3vw);
  }
  #logout-btn {
    font-size: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/driver-details/driver-details.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AACJ;;AAEA;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AACJ;AAAI;EACI,yBAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;AAER;;AAEA;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;AACJ;;AAEA;EACI,2BAAA;EACA,YAAA;EACA,mBAAA;AACJ;;AAEA;EACI,2BAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EAEQ;IACA,yBAAA;IACA,iCAAA;EAAN;EAIE;IACI,iBAAA;EAFN;AACF","sourcesContent":["#driver-details {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    height: 100%;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n#driver-details-header {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    background-color: white;\r\n    width: 100%;\r\n    h4 {\r\n        margin: 5px 30px 5px 70px;\r\n        color: var(--color-primary);\r\n        flex-grow: 1;\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n#driver-details-body {\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    overflow-y: auto;\r\n    row-gap: 30px;\r\n    padding-top: 5px;\r\n}\r\n\r\n#driver-details-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n    height: max(380px, 75%);\r\n}\r\n\r\n#driver-details-form, #security-details, #update-info {\r\n    width: max(280px, 60%);\r\n}\r\n\r\n#delete-account-btn {\r\n    width: 100%;\r\n}\r\n\r\n#driver-details-list {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    width: 100%;\r\n    overflow-y: auto;\r\n}\r\n\r\n.form-control-input {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    background-color: white;\r\n    padding: 5px 15px;\r\n    margin: 3px 0;\r\n}\r\n\r\n.form-control {\r\n    color: var(--color-primary);\r\n    border: none;\r\n    padding: 0.375rem 0;\r\n}\r\n\r\n.form-label {\r\n    color: var(--color-success);\r\n    margin-bottom: 2px;\r\n}\r\n\r\n#update-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n}\r\n\r\n#logout-btn {\r\n    color: var(--color-primary);\r\n    font-weight: 600;\r\n    font-size: 0.8rem;\r\n    text-decoration: underline;\r\n}\r\n\r\n#unsaved-changes-warning {\r\n    font-size: 0.8rem;\r\n}\r\n\r\n.invalid-form-field-warning {\r\n    font-size: 0.7rem;\r\n}\r\n\r\n#invalid-form-warning, #unsaved-changes-warning, .invalid-form-field-warning {\r\n    color: red;\r\n}\r\n\r\n@media only screen and (max-width: 300px) {\r\n    #driver-details-header {\r\n        h4 {\r\n        margin: 5px 30px 5px 30px;\r\n        font-size: calc(1.175rem + 0.3vw);\r\n        }\r\n    }\r\n\r\n    #logout-btn {\r\n        font-size: 0.8rem;\r\n    }\r\n  }\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
